export default __webpack_public_path__ + "static/media/liane2.cbd9df70.png";